import { User, CognitoUser } from "@impulse/sdp-shared-models";

import { CurrentUserData } from "../../models";

export abstract class LoggedInUser implements CognitoUser {

	public accountName = "";
	public email = "";
	public primary = false;
	public admin = false;
	public firstName = "";
	public lastName = "";
	public roles: string[] = [];
	public createdAt = 0;
	public updatedAt = 0;
	public type: "cognito" = "cognito";
	public version: User.Version = 4;
	public hideWizard = false;
	public disabled = false;
	public mfaDevice!: User.MfaDevice;

	public abstract isExpired(): boolean;
	public abstract refreshSession(): Promise<LoggedInUser>;
	public abstract getAuthToken(): string;
	public abstract signOut(): void;
	public abstract toJSONString(): string;

	public setFieldsFromUserData(userData: CurrentUserData) {
		this.accountName = userData.accountName;
		this.email = userData.user.email;
		this.primary = userData.user.primary;
		this.admin = userData.user.admin;
		this.firstName = userData.user.firstName;
		this.lastName = userData.user.lastName;
		this.createdAt = userData.user.createdAt;
		this.updatedAt = userData.user.updatedAt;
		this.version = userData.user.version;
		this.hideWizard = userData.user.hideWizard;
		this.disabled = userData.user.disabled;
		this.mfaDevice = userData.user.mfaDevice!;
	}

	public getUserData(): CurrentUserData {
		return {
			accountName: this.accountName,
			user: {
				email: this.email,
				primary: this.primary,
				admin: this.admin,
				firstName: this.firstName,
				lastName: this.lastName,
				createdAt: this.createdAt,
				updatedAt: this.updatedAt,
				version: this.version,
				hideWizard: this.hideWizard,
				disabled: this.disabled,
				type: this.type,
				mfaDevice: this.mfaDevice
			},
		};
	}
}
